import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdAttachFile, MdBuild, MdClass, MdDelete, MdDone, MdEmail, MdExplore, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility, MdTranslate } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function ResearcherAccountSelect() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    

    return (
        <div className={`${i18n.language==="en"?"font-urban":(i18n.language==="si"?"font-noto":"font-mukta")} overflow-x-hidden w-screen xl:pt-[20px]`}>
            <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                    <MdArrowBack size={25} className="md:hidden" onClick={() => {
                        navigate('/mobile/researcher/dashboard')
                    }} />
                    <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                        navigate('/mobile/researcher/dashboard')
                    }} />
                    <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                        navigate('/desktop/researcher/dashboard')
                    }} />
                    <p className="text-[16px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t269')}</p>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/list')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSchool size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSchool size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t6')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/translator/list')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdTranslate size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdTranslate size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t5')}</p>
                    </div>
                </div>
            </div>

            <div className="hidden xl:grid grid-cols-4 mt-[30px] 2xl:mt-[50px] ml-[80px] mr-[70px] 2xl:ml-[100px] 2xl:mr-[100px]">
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/researcher/list')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdSchool size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] 2xl:text-[20px] font-bold pr-[10px]">{t('t6')}</p>
                    </div>
                </div>
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/researcher/translator/list')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdTranslate size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] 2xl:text-[20px] font-bold pr-[10px]">{t('t5')}</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ResearcherAccountSelect;